import type { Responsive } from '#types/common'

export const getValueForBreakpoint = <T>(br: keyof Responsive, obj?: T | Responsive<T>): T | undefined =>
  isObject(obj) ? (obj[br] ?? obj.md ?? obj.sm) : obj
